import { Near, keyStores, utils } from 'near-api-js';
import BN from 'bn.js';
import getConfig, { getExtraStablePoolConfig } from './config';
import SpecialWallet from './SpecialWallet';
import {
  getCurrentWallet,
  walletsRejectError,
} from '../utils/wallets-integration';

import { Transaction as WSTransaction } from '@near-wallet-selector/core';

import { ledgerTipTrigger } from '../utils/wallets-integration';
import {
  addQueryParams,
  extraWalletsError,
} from '../utils/wallets-integration';
import { TRANSACTION_WALLET_TYPE } from '../components/layout/transactionTipPopUp';

const config = getConfig();

export const REF_FI_CONTRACT_ID = config.REF_FI_CONTRACT_ID;

export const POOL_TOKEN_REFRESH_INTERVAL = config.POOL_TOKEN_REFRESH_INTERVAL;

export const REF_VE_CONTRACT_ID = config.REF_VE_CONTRACT_ID;

const STABLE_TOKEN_IDS = config.STABLE_TOKEN_IDS;

const USDTT_USDCC_USDT_USDC_TOKEN_IDS = config.USDTT_USDCC_USDT_USDC_TOKEN_IDS;

const USDCW_TOKEN_IDS = config.USDCW_TOKEN_IDS;

const USDT_USDC_TOKEN_IDS = config.USDT_USDC_TOKEN_IDS;
const FRAX_USDC_TOKEN_IDS = config.FRAX_USDC_TOKEN_IDS;
const Frax_SFrax_TOKEN_IDS = config.Frax_SFrax_TOKEN_IDS;
const ZNEARnM_USDC_TOKEN_IDS = config.ZNEARnM_USDC_TOKEN_IDS;

export const STABLE_POOL_ID = config.STABLE_POOL_ID;

export const USDTT_USDCC_USDT_USDC_POOL_ID =
  config.USDTT_USDCC_USDT_USDC_POOL_ID;

const STABLE_POOL_USN_ID = config.STABLE_POOL_USN_ID;

const STABLE_TOKEN_USN_IDS = config.STABLE_TOKEN_USN_IDS;

export const REF_FARM_BOOST_CONTRACT_ID = config.REF_FARM_BOOST_CONTRACT_ID;

export const USDT_USDC_POOL_ID = config.USDT_USDC_POOL_ID;
export const FRAX_USDC_POOL_ID = config.FRAX_USDC_POOL_ID;

export const USDCW_POOL_ID = config.USDCW_POOL_ID;
export const Frax_SFrax_POOL_ID = config.Frax_SFrax_POOL_ID;
export const ZNEARnM_USDC_POOL_ID = config.ZNEARnM_USDC_POOL_ID;

export const {
  BTCIDS,
  CUSDIDS,
  BTC_STABLE_POOL_ID,
  CUSD_STABLE_POOL_ID,
  STNEAR_POOL_ID,
  STNEARIDS,
  BTC_STABLE_POOL_INDEX,
  CUSD_STABLE_POOL_INDEX,
  STNEAR_POOL_INDEX,
  LINEARIDS,
  LINEAR_POOL_INDEX,
  LINEAR_POOL_ID,
  NEARX_POOL_ID,
  NEARX_POOL_INDEX,
  NEARXIDS,
  NEW_NEARXIDS,
  NEW_NEARX_POOL_ID,
  NEW_NEARX_POOL_INDEX,
  USDTIDS,
  USDT_POOL_ID,
  USDT_POOL_INDEX,
  USDTT_USDCC_USDT_USDC_POOL_INDEX,
  USDT_USDC_POOL_INDEX,
  FRAX_USDC_POOL_INDEX,
  USDCW_TOKEN_INDEX,
  Frax_SFrax_POOL_INDEX,
  ZNEARnM_USDC_POOL_INDEX,
} = getExtraStablePoolConfig();

export const extraStableTokenIds = BTCIDS.concat(LINEARIDS)
  .concat(USDTIDS)
  .concat(STNEARIDS)
  .concat(NEARXIDS)
  .concat(CUSDIDS)
  .concat(NEW_NEARXIDS)
  .concat(USDTIDS)
  .filter((_) => !!_);

export const isRatedPool = (id: string | number) => {
  return getExtraStablePoolConfig().RATED_POOLS_IDS.includes(id.toString());
};

export const AllStableTokenIds = new Array(
  ...new Set(
    STABLE_TOKEN_USN_IDS.concat(STABLE_TOKEN_IDS)
      .concat(extraStableTokenIds)
      .concat(USDTT_USDCC_USDT_USDC_TOKEN_IDS)
      .concat(USDT_USDC_TOKEN_IDS)
      .concat(FRAX_USDC_TOKEN_IDS)
      .concat(USDCW_TOKEN_IDS)
      .concat(Frax_SFrax_TOKEN_IDS)
      .concat(ZNEARnM_USDC_TOKEN_IDS)
  )
);

export const isStableToken = (id: string) => {
  return AllStableTokenIds.includes(id);
};

// export const TOKEN_BLACK_LIST = [NEARXIDS[0], 'meta-token.near'];
export const TOKEN_BLACK_LIST = [NEARXIDS[0], BTCIDS[1]];

export const ALL_STABLE_POOL_IDS = [
  STABLE_POOL_ID,
  USDTT_USDCC_USDT_USDC_POOL_ID,
  USDCW_POOL_ID,
  STABLE_POOL_USN_ID,
  BTC_STABLE_POOL_ID,
  STNEAR_POOL_ID,
  CUSD_STABLE_POOL_ID,
  LINEAR_POOL_ID,
  NEARX_POOL_ID,
  NEW_NEARX_POOL_ID,
  USDT_POOL_ID,
  USDT_USDC_POOL_ID,
  FRAX_USDC_POOL_ID,
  Frax_SFrax_POOL_ID,
  ZNEARnM_USDC_POOL_ID,
]
  .filter((_) => _)
  .map((id) => id.toString());

export const BLACKLIST_POOL_IDS = config.BLACKLIST_POOL_IDS;

export const filterBlackListPools = (pool: any & { id: any }) =>
  !BLACKLIST_POOL_IDS.includes(pool.id.toString());

const STABLE_TOKEN_INDEX = config.STABLE_TOKEN_INDEX;

const STABLE_TOKEN_USN_INDEX = config.STABLE_TOKEN_USN_INDEX;

export const getStableTokenIndex = (stable_pool_id: string | number) => {
  const id = stable_pool_id.toString();
  switch (id) {
    case STABLE_POOL_ID.toString():
      return STABLE_TOKEN_INDEX;
    case STABLE_POOL_USN_ID.toString():
      return STABLE_TOKEN_USN_INDEX;
    case BTC_STABLE_POOL_ID:
      return BTC_STABLE_POOL_INDEX;
    case STNEAR_POOL_ID:
      return STNEAR_POOL_INDEX;
    case CUSD_STABLE_POOL_ID:
      return CUSD_STABLE_POOL_INDEX;
    case LINEAR_POOL_ID:
      return LINEAR_POOL_INDEX;
    case NEARX_POOL_ID:
      return NEARX_POOL_INDEX;
    case NEW_NEARX_POOL_ID:
      return NEW_NEARX_POOL_INDEX;

    case USDT_POOL_ID:
      return USDT_POOL_INDEX;
    case USDTT_USDCC_USDT_USDC_POOL_ID.toString():
      return USDTT_USDCC_USDT_USDC_POOL_INDEX;
    case USDT_USDC_POOL_ID.toString():
      return USDT_USDC_POOL_INDEX;
    case FRAX_USDC_POOL_ID.toString():
      return FRAX_USDC_POOL_INDEX;
    case USDCW_POOL_ID.toString():
      return USDCW_TOKEN_INDEX;
    case Frax_SFrax_POOL_ID.toString():
      return Frax_SFrax_POOL_INDEX;
    case ZNEARnM_USDC_POOL_ID.toString():
      return ZNEARnM_USDC_POOL_INDEX;
  }
};

export const isStablePool = (id: string | number) => {
  return ALL_STABLE_POOL_IDS.map((id) => id.toString()).includes(id.toString());
};

export const BTC_CLASS_STABLE_POOL_IDS = [BTC_STABLE_POOL_ID];

export const NEAR_CLASS_STABLE_POOL_IDS = [
  LINEAR_POOL_ID,
  STNEAR_POOL_ID,
  NEW_NEARX_POOL_ID,
];

export const USD_CLASS_STABLE_POOL_IDS = [
  STABLE_POOL_ID.toString(),
  STABLE_POOL_USN_ID.toString(),
  CUSD_STABLE_POOL_ID,
  USDT_POOL_ID,
  USDTT_USDCC_USDT_USDC_POOL_ID.toString(),
  USDT_USDC_POOL_ID?.toString(),
  FRAX_USDC_POOL_ID?.toString(),
  USDCW_POOL_ID?.toString(),
  Frax_SFrax_POOL_ID?.toString(),
  ZNEARnM_USDC_POOL_ID?.toString(),
];

export const REF_FARM_CONTRACT_ID = config.REF_FARM_CONTRACT_ID;

export const REF_UNI_V3_SWAP_CONTRACT_ID = config.REF_UNI_V3_SWAP_CONTRACT_ID;
export const REF_UNI_SWAP_CONTRACT_ID = config.REF_UNI_SWAP_CONTRACT_ID;

export const REF_TOKEN_ID = config.REF_TOKEN_ID;
export const USDC_TOKEN_ID = config.USDC_TOKEN_ID;
export const USDT_TOKEN_ID = config.USDT_TOKEN_ID;
export const USDCe_TOKEN_ID = config.USDCe_TOKEN_ID;
export const USDTe_TOKEN_ID = config.USDTe_TOKEN_ID;
export const BRRR_TOKEN_ID = config.BRRR_TOKEN_ID;
const XREF_TOKEN_ID = getConfig().XREF_TOKEN_ID;
export const LP_STORAGE_AMOUNT = '0.01';

export const ONE_YOCTO_NEAR = '0.000000000000000000000001';

export const keyStore = new keyStores.BrowserLocalStorageKeyStore();
//@ts-ignore
keyStore.reKey = () => {};

export const near = new Near({
  keyStore,
  headers: {},
  ...config,
});
export const wallet = new SpecialWallet(near, REF_FI_CONTRACT_ID);

export const getGas = (gas?: string) =>
  gas ? new BN(gas) : new BN('100000000000000');
export const getAmount = (amount: string) =>
  amount ? new BN(utils.format.parseNearAmount(amount)) : new BN('0');

export interface RefFiViewFunctionOptions {
  contractId?: string;
  methodName: string;
  args?: object;
}

export interface RefFiFunctionCallOptions extends RefFiViewFunctionOptions {
  gas?: string;
  amount?: string;
  deposit?: string;
}

export const refFiViewFunction = ({
  methodName,
  args,
}: RefFiViewFunctionOptions) => {
  return wallet.account().viewFunction(REF_FI_CONTRACT_ID, methodName, args);
};

export const refVeViewFunction = ({
  methodName,
  args,
}: RefFiViewFunctionOptions) => {
  return wallet.account().viewFunction(REF_VE_CONTRACT_ID, methodName, args);
};

// Without a DCL (concentrated liquidity) contract every DCL view resolves to
// an empty result of the shape callers expect, so shared screens (swap, nav
// balances, your liquidity) keep working with classic pools only.
const emptyDclView = (methodName: string) => {
  if (methodName === 'list_user_assets') return Promise.resolve({});
  if (methodName.startsWith('list_')) return Promise.resolve([]);
  return Promise.resolve(null);
};

export const refSwapV3ViewFunction = ({
  methodName,
  args,
}: RefFiViewFunctionOptions) => {
  if (!REF_UNI_V3_SWAP_CONTRACT_ID) return emptyDclView(methodName);
  return wallet
    .account()
    .viewFunction(REF_UNI_V3_SWAP_CONTRACT_ID, methodName, args);
};
export const refSwapV3OldVersionViewFunction = ({
  methodName,
  args,
}: RefFiViewFunctionOptions) => {
  if (!REF_UNI_SWAP_CONTRACT_ID) return emptyDclView(methodName);
  return wallet
    .account()
    .viewFunction(REF_UNI_SWAP_CONTRACT_ID, methodName, args);
};

export interface Transaction {
  receiverId: string;
  functionCalls: RefFiFunctionCallOptions[];
}

export const executeMultipleTransactions = async (
  transactions: Transaction[],
  callbackUrl?: string
) => {
  const { wallet } = getCurrentWallet();

  const wstransactions: WSTransaction[] = [];

  transactions.forEach((transaction) => {
    wstransactions.push({
      signerId: wallet.getAccountId()!,
      receiverId: transaction.receiverId,
      actions: transaction.functionCalls.map((functionCallOptions) => {
        return {
          type: 'FunctionCall',
          params: {
            methodName: functionCallOptions.methodName,
            args: functionCallOptions.args,
            gas: getGas(functionCallOptions.gas).toNumber().toFixed(),
            deposit: utils.format.parseNearAmount(
              functionCallOptions.amount || '0'
            )!,
          },
        };
      }),
    });
  });

  await ledgerTipTrigger(wallet);

  return (await wallet.wallet())
    .signAndSendTransactions({
      transactions: wstransactions,
      callbackUrl,
    })
    .then((outcome) => {
      if (!outcome) return;

      const transactionHashes = (
        Array.isArray(outcome) ? outcome : [outcome]
      )?.map((transactionOutcome) => transactionOutcome.transaction.hash);
      const parsedTransactionHashes = transactionHashes?.join(',');
      const redirectUrl = addQueryParams(
        window.location.origin + window.location.pathname,
        {
          [TRANSACTION_WALLET_TYPE.WalletSelector]: parsedTransactionHashes,
        }
      );

      window.location.href = redirectUrl;
    })
    .catch((error: Error) => {
      if (extraWalletsError.includes(error.message)) {
        return;
      }

      if (
        !walletsRejectError.includes(error.message) &&
        !extraWalletsError.includes(error.message)
      ) {
        sessionStorage.setItem('WALLETS_TX_ERROR', error.message);
      }

      window.location.reload();
    });
};

// Farm views that return maps keyed by seed/token rather than lists.
const FARM_MAP_VIEWS = [
  'list_farmer_seeds',
  'list_farmer_rewards',
  'list_user_seeds',
  'list_rewards',
  'list_seeds',
  'get_unclaimed_rewards',
];

// Without a farm contract every farm view resolves to an empty result, so
// pool pages that show farm info keep working.
const emptyFarmView = (methodName: string) => {
  if (FARM_MAP_VIEWS.includes(methodName)) return Promise.resolve({});
  if (methodName.startsWith('list_')) return Promise.resolve([]);
  return Promise.resolve(null);
};

export const refFarmViewFunction = ({
  methodName,
  args,
}: RefFiViewFunctionOptions) => {
  if (!REF_FARM_CONTRACT_ID) return emptyFarmView(methodName);
  return wallet.account().viewFunction(REF_FARM_CONTRACT_ID, methodName, args);
};

export const executeFarmMultipleTransactions = async (
  transactions: Transaction[],
  callbackUrl?: string
) => {
  return executeMultipleTransactions(transactions, callbackUrl);
};

interface RefContractViewFunctionOptions extends RefFiViewFunctionOptions {
  gas?: string;
  amount?: string;
  contractId?: string;
}

export const refContractViewFunction = ({
  methodName,
  args,
}: RefContractViewFunctionOptions) => {
  return wallet.account().viewFunction(XREF_TOKEN_ID, methodName, args);
};

export const getAccountNearBalance = async (accountId: string) => {
  // const provider = new providers.JsonRpcProvider({
  //   url: getConfig().nodeUrl,
  // });

  // return provider
  //   .query<AccountView>({
  //     request_type: 'view_account',
  //     finality: 'final',
  //     account_id: accountId,
  //   })
  //   .then((data) => ({ available: data.amount }));
  const nearConnection = await near.account(
    getCurrentWallet().wallet.getAccountId()
  );
  return nearConnection
    .getAccountBalance()
    .then(({ available }) => ({ available }))
    .catch((error) => {
      return { available: '0' };
    });
};

export const refFarmBoostViewFunction = ({
  methodName,
  args,
}: RefFiViewFunctionOptions) => {
  if (!REF_FARM_BOOST_CONTRACT_ID) return emptyFarmView(methodName);
  return wallet
    .account()
    .viewFunction(REF_FARM_BOOST_CONTRACT_ID, methodName, args);
};

export const refFarmBoostFunctionCall = async ({
  methodName,
  args,
  gas,
  amount,
}: RefFiFunctionCallOptions) => {
  const transaction: Transaction = {
    receiverId: REF_FARM_BOOST_CONTRACT_ID,
    functionCalls: [
      {
        methodName,
        args,
        amount,
        gas,
      },
    ],
  };

  return await executeMultipleTransactions([transaction]);
};

export const lockerViewFunction = ({
  methodName,
  args,
}: RefFiViewFunctionOptions) => {
  return wallet
    .account()
    .viewFunction(config.REF_TOKEN_LOCKER_CONTRACT_ID, methodName, args);
};
